import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import KTWizard from 'src/app/crm/assets/js/components/wizard';
import { KTUtil } from 'src/app/crm/assets/js/components/util';
import {ProjectsDataService} from '../projects-data.service';
import {Options} from 'select2';
import {SelectLocationTable} from '../../../../shared/location-select.table';
import {Select2OptionData} from 'ng-select2';
import {SelectFieldsTable} from '../../../../jobboard/modules/jobs/create-job/select-fields.table';
import {CompanyValuesModel} from '../../../shared/models/companyValues.model';
import {ResponsibilityModel} from '../../../shared/models/responsibility.model';
import {skillRequiredModel} from '../../../shared/models/skillRequired.model';
import {TechnicalTestingModel} from '../../../shared/models/technicalTesting.model';
import {PsychologicalTestingModel} from '../../../shared/models/psychologicalTesting.model';
import {ForeignLanguageModel} from '../../../shared/models/foreignLanguage.model';
import {NgForm} from '@angular/forms';
import {ChannelsModel} from '../../../shared/models/channels.model';
import {TestsModel} from '../../../shared/models/tests.model';
import {RecruitersModel} from '../../../shared/models/recruiters.model';
import {Router} from '@angular/router';
import { Injectable, Type } from '@angular/core';

@Component({
    selector: 'app-create-project',
    templateUrl: './create-project.component.html',
    styleUrls: ['./create-project.component.scss'],
    providers: [SelectLocationTable, SelectFieldsTable]
})
export class CreateProjectComponent implements OnInit, AfterViewInit, OnDestroy {


    @ViewChild('wizard', { static: true }) el: ElementRef;

    formResponse: boolean;
    formSent: boolean;


    project: any = [];

    serverResp = false;
    formHasBeenSend = false;
    formSuccessfulSend = false;
    serverErrorMessages: string;

    contractNumbers: any = [];

    recruitmentSteps: any = [
        'Atragere candidati / Sourcing',
        'Selectie CVs / Screening',
        'Pretestare',
        'Interviuri ABJ',
        'Teste ABJ',
        'Propunere candidati lista lunga',
        'Acceptare candidati de catre client',
        'Test 1 client',
        'Interviu 1 client',
        'Lista scurta client',
        'Evaluare/test 2 client',
        'Interviu 2 client',
        'Candidat final/top',
        'Ofertare candidat',
        'Raspuns candidat',
        'Negociere pachet',
        'Preaviz candidat',
        'Start job/ start garantie',
        'Intocmire plan de inductie/onbording',
        'Feedback 1 candidat si angajator( dupa 1 sapt de activ)',
        'Evaluare interna ABJ proiect/evaluare  ABJ  si recrutor intern, extern',
        'Evaluare externa ABJ proiect/evaluare ABJ si  recrutor ABJ',
        'Feedback 2 candidat si angajator(mijloc garantie)',
        'Feedback 3 candidat si angajator(final garantie)',
        'Evaluare finala, interna si externa, proiect',
        'Alte aspecte specifice proiectului (txt)'
    ];

    demoContracts: any = [
        1,
        2,
        3,
        4,
        5,

    ];

    demoFiscalBill: any = [
        1,
        2,
        3,
        4,
        5,

    ];

    submitted = false;
    wizard: any;

    clientsMainArray: any = [];
    clientsNameArray: any = [] ;
    clientsNameObject: any = [];

    recruitersMainArray: any = [];
    recruitersNameArray: any = [];
    recruitersDataLoaded: boolean;

    crmUsersMainArray: any = [];
    crmUsersNameArray: any = [];
    crmUsersDataLoaded: boolean;

    companyName: string;
    dataLoaded: boolean;

    public clientsOptions: Options;
    public multiSelectOp: Options;
    public singleOptions: Options;

    selectCareerPossibility: Array<Select2OptionData>;
    selectOtherBenefit: Array<Select2OptionData>;
    selectWorkingTools: Array<Select2OptionData>;
    foreignLanguages: any;
    driverLicense: Array<Select2OptionData>;

    // Declare the form
    public form: {
        companyValues: CompanyValuesModel[],
        responsibility: ResponsibilityModel[],
        skillRequired: skillRequiredModel[],
        technicalTesting: TechnicalTestingModel[],
        psychologicalTesting: PsychologicalTestingModel[],
        foreignLanguage: ForeignLanguageModel[],
        internChannel: ChannelsModel[],
        externChannel: ChannelsModel[],
        internalTechnicalTest: TestsModel[],
        externalTechnicalTest: TestsModel[],
        internalPhysiologicalTest: TestsModel[],
        externalPhysiologicalTest: TestsModel[],
        otherTest: TestsModel[],
        recruiters: RecruitersModel[]
    };


    constructor(private projectsService: ProjectsDataService,
                private locationSelect: SelectLocationTable,
                private selectFields: SelectFieldsTable,
                private router: Router) {

        this.form = {
            companyValues: [],
            responsibility: [],
            skillRequired: [],
            technicalTesting: [],
            psychologicalTesting: [],
            foreignLanguage: [],
            internChannel: [],
            externChannel: [],
            internalTechnicalTest: [],
            externalTechnicalTest: [],
            internalPhysiologicalTest: [],
            externalPhysiologicalTest: [],
            otherTest: [],
            recruiters: []
        };
    }

    budget: any = {
        estimatedOther: 0,
        estimatedCommunication: 0,
        estimatedTravel:0,
        performedTravel: 0,
        performedCommunication:0,
        performedOther: 0
    }

    totalEst: number = 0;
    totalReal: number = 0;
    budgetDiff: number = 0;

    getTotalEst() {
        let total = 0;

        for (var i = 0; i < this.form.internChannel.length; i++) {
            if (this.form.internChannel[i]) {
                total += this.form.internChannel[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.externChannel.length; i++) {
            if (this.form.externChannel[i]) {
                total += this.form.externChannel[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.internalTechnicalTest.length; i++) {
            if (this.form.internalTechnicalTest[i]) {
                total += this.form.internalTechnicalTest[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.externalTechnicalTest.length; i++) {
            if (this.form.externalTechnicalTest[i]) {
                total += this.form.externalTechnicalTest[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.internalPhysiologicalTest.length; i++) {
            if (this.form.internalPhysiologicalTest[i]) {
                total += this.form.internalPhysiologicalTest[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.externalPhysiologicalTest.length; i++) {
            if (this.form.externalPhysiologicalTest[i]) {
                total += this.form.externalPhysiologicalTest[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.otherTest.length; i++) {
            if (this.form.otherTest[i]) {
                total += this.form.otherTest[i].estimatedCost;
            }
        }

        for (var i = 0; i < this.form.recruiters.length; i++) {
            if (this.form.recruiters[i]) {
                total += this.form.recruiters[i].feeEstimatedVariable + this.form.recruiters[i].bonusEstimatedVariable;
            }
        }

        this.totalEst = this.budget.estimatedOther + this.budget.estimatedCommunication + this.budget.estimatedTravel + total;

        return this.totalEst;
    }

    getTotalReal() {
        let totalReal = 0;

        for (var i = 0; i < this.form.internChannel.length; i++) {
            if (this.form.internChannel[i]) {
                totalReal += this.form.internChannel[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.externChannel.length; i++) {
            if (this.form.externChannel[i]) {
                totalReal += this.form.externChannel[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.internalTechnicalTest.length; i++) {
            if (this.form.internalTechnicalTest[i]) {
                totalReal += this.form.internalTechnicalTest[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.externalTechnicalTest.length; i++) {
            if (this.form.externalTechnicalTest[i]) {
                totalReal += this.form.externalTechnicalTest[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.internalPhysiologicalTest.length; i++) {
            if (this.form.internalPhysiologicalTest[i]) {
                totalReal += this.form.internalPhysiologicalTest[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.externalPhysiologicalTest.length; i++) {
            if (this.form.externalPhysiologicalTest[i]) {
                totalReal += this.form.externalPhysiologicalTest[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.otherTest.length; i++) {
            if (this.form.otherTest[i]) {
                totalReal += this.form.otherTest[i].finalCost;
            }
        }

        for (var i = 0; i < this.form.recruiters.length; i++) {
            if (this.form.recruiters[i]) {
                totalReal += this.form.recruiters[i].feeEstimatedPerformed + this.form.recruiters[i].bonusEstimatedPerformed;
            }
        }

        this.totalReal = this.budget.performedTravel + this.budget.performedCommunication + this.budget.performedOther + totalReal;

        return this.totalReal;
    }

    getDifference() {
        this.budgetDiff = this.totalEst - this.totalReal;
        return this.budgetDiff;
    }

    // --- Dropdown for country and city
    countries = this.locationSelect.Countries;
    cities: Array<any> = [];
    changeCountry(country: any) {
        this.cities = this.countries.find((cntry: any) => cntry.name == country.target.value).cities;
    }
    // --- End of dropdown for country and city


    ngOnInit() {

        this.selectCareerPossibility = this.selectFields.selectCareerPossibility;
        this.selectOtherBenefit = this.selectFields.selectOtherBenefit;
        this.selectWorkingTools = this.selectFields.selectWorkingTools;
        this.foreignLanguages = this.selectFields.languages;
        this.driverLicense = this.selectFields.driveLicense;

        this.clientsOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.singleOptions = {
            width: '100%',
            multiple: false,
            allowClear: true
        }

        this.multiSelectOp = {
            width: '100%',
            multiple: true,
            allowClear: true
        }

        // Get all contracts
        this.projectsService.getContracts().subscribe(resp => {
            this.contractNumbers = resp;
        })



        // Get all clients
        this.projectsService.getAllClients().subscribe(resp => {
            this.clientsMainArray = resp;
            this.clientsMainArray.forEach((value) => {
                 this.clientsNameArray.push({id: value.id, text: value.companyName});
            });
            this.dataLoaded = true;
        })

        // Get all recruiters
        this.projectsService.getAllRecruiters().subscribe(recruiters => {
            this.recruitersMainArray = recruiters;
            this.recruitersMainArray.forEach((value) => {
                this.recruitersNameArray.push({id: value.userId, text: value.name});
            });
            this.recruitersDataLoaded = true;
        })

        // Get all CRM Users
        this.projectsService.getAllCRMUsers().subscribe(users => {
            this.crmUsersMainArray = users;
            this.crmUsersMainArray.forEach((value) => {
                this.crmUsersNameArray.push({id: value.userId, text: value.name});
            });
            this.crmUsersDataLoaded = true;

        })
    }

    ngAfterViewInit(): void {
        // Initialize form wizard
        this.wizard = new KTWizard(this.el.nativeElement, {
            startStep: 1,
            clickableSteps: true
        });

        // Validation before going to next page
        this.wizard.on('beforeNext', (wizardObj) => {
            // https://angular.io/guide/forms
            // https://angular.io/guide/form-validation

            // validate the form and use below function to stop the wizard's step
            // wizardObj.stop();
        });

        // Change event
        this.wizard.on('change', (wizard: any) => {
            setTimeout(() => {
                KTUtil.scrollTop();
            }, 500);
        });


    }

    onSubmit(addForm: NgForm) {


        let recruitSteps = [];
        for (let key of Object.keys(addForm.value.recruitmentStage)) {
            let step = addForm.value.recruitmentStage[key];
            recruitSteps.push(step);
        }

        let companyValuesArray = [];
        for (let key of Object.keys(addForm.value.companyValues)) {
            let value = addForm.value.companyValues[key];
            if (value != "") {
                companyValuesArray.push(value);
            }
        }

        let responsibilityArray = [];
        for (let key of Object.keys(addForm.value.responsibility)) {
            let responsibility = addForm.value.responsibility[key];
            if (responsibility != "") {
                responsibilityArray.push(responsibility);
            }
        }

        let skillsArray = [];
        for (let key of Object.keys(addForm.value.skillRequired)) {
            let skill = addForm.value.skillRequired[key];
            if (skill != "") {
                skillsArray.push(skill);
            }
        }

        let technicalTestingArray = [];
        for (let key of Object.keys(addForm.value.technicalTesting)) {
            let technicalTesting = addForm.value.technicalTesting[key];
            if (technicalTesting != "") {
                technicalTestingArray.push(technicalTesting);
            }
        }

        let psychologicalTestingArray = [];
        for (let key of Object.keys(addForm.value.psychologicalTesting)) {
            let psychologicalTesting = addForm.value.psychologicalTesting[key];
            if (psychologicalTesting != "") {
                psychologicalTestingArray.push(psychologicalTesting);
            }
        }

        let foreignLanguageArray = [];
        for (let key of Object.keys(addForm.value.foreignLanguage)) {
            let foreignLanguage = addForm.value.foreignLanguage[key];
            if (foreignLanguage != "") {
                foreignLanguageArray.push(foreignLanguage);
            }
        }

        let internChannelArray = [];
        for (let key of Object.keys(addForm.value.internChannel)) {
            let internChannel = addForm.value.internChannel[key];
            if (internChannel != "") {
                internChannelArray.push(internChannel);
            }
        }

        let externChannelArray = [];
        for (let key of Object.keys(addForm.value.externChannel)) {
            let externChannel = addForm.value.externChannel[key];
            if (externChannel != "") {
                externChannelArray.push(externChannel);
            }
        }

        let internalTechnicalTestArray = [];
        for (let key of Object.keys(addForm.value.internalTechnicalTest)) {
            let internalTechnicalTest = addForm.value.internalTechnicalTest[key];
            if (internalTechnicalTest != "") {
                internalTechnicalTestArray.push(internalTechnicalTest);
            }
        }


        let externalTechnicalTestArray = [];
        for (let key of Object.keys(addForm.value.externalTechnicalTest)) {
            let externalTechnicalTest = addForm.value.externalTechnicalTest[key];
            if (externalTechnicalTest != "") {
                externalTechnicalTestArray.push(externalTechnicalTest);
            }
        }

        let internalPhysiologicalTestArray = [];
        for (let key of Object.keys(addForm.value.internalPhysiologicalTest)) {
            let internalPhysiologicalTest = addForm.value.internalPhysiologicalTest[key];
            if (internalPhysiologicalTest != "") {
                internalPhysiologicalTestArray.push(internalPhysiologicalTest);
            }
        }

        let externalPhysiologicalTestArray = [];
        for (let key of Object.keys(addForm.value.externalPhysiologicalTest)) {
            let externalPhysiologicalTest = addForm.value.externalPhysiologicalTest[key];
            if (externalPhysiologicalTest != "") {
                externalPhysiologicalTestArray.push(externalPhysiologicalTest);
            }
        }


        let otherTestArray = [];
        for (let key of Object.keys(addForm.value.otherTest)) {
            let otherTest = addForm.value.otherTest[key];
            if (otherTest != "") {
                otherTestArray.push(otherTest);
            }
        }


        let recruitersArray = [];
        for (let key of Object.keys(addForm.value.recruiters)) {
            let recruiters = addForm.value.recruiters[key];
            if (recruiters != "") {
                recruitersArray.push(recruiters);
            }
        }

        let projResp = [];
        if (addForm.value.responsibleIdForSimilarProjects != "") {
            let similarProjResp = addForm.value.responsibleIdForSimilarProjects;
            similarProjResp.forEach(function (value) {
                projResp.push({name: '', userId: value})
            });
        }


        this.project = {
            id: 'string',
            name: addForm.value.name,
            clientUserId: addForm.value.clientUserId,
            clientName: undefined,
            projectNumber: 0,
            contract: addForm.value.contract === "" ? undefined : addForm.value.contract,
            fiscalBill: addForm.value.fiscalBill === "" ? undefined : addForm.value.fiscalBill,
            projectManagerName: addForm.value.projectManagerName,
            projectManagerLastName: addForm.value.projectManagerLastName,
            projectManagerBranch: addForm.value.projectManagerBranch,
            projectManagerEmail: addForm.value.projectManagerEmail,
            projectManagerTelephone: addForm.value.projectManagerTelephone,
            projectManagerLevel: addForm.value.projectManagerLevel === "" ? undefined : addForm.value.projectManagerLevel,
            recruiterFirstName: addForm.value.recruiterFirstName,
            recruiterLastName: addForm.value.recruiterLastName,
            recruiterBranch: addForm.value.recruiterBranch,
            recruiterEmail: addForm.value.recruiterEmail,
            recruiterTelephone: addForm.value.recruiterTelephone,
            recruiterLevel: addForm.value.recruiterLevel === "" ? undefined : addForm.value.recruiterLevel,
            managerName: addForm.value.managerName,
            managerTelephone: addForm.value.managerTelephone,
            managerEmail: addForm.value.managerEmail,
            employingCompany: addForm.value.employingCompany,
            jobName: addForm.value.jobName,
            numberAvailableJobs: addForm.value.numberAvailableJobs,
            jobCountry: addForm.value.jobCountry,
            jobCities: addForm.value.jobCities === "" ? undefined : addForm.value.jobCities,
            levelJob: addForm.value.levelJob === "" ? undefined : addForm.value.levelJob,
            jobType: addForm.value.jobType,
            contractType: addForm.value.contractType,
            jobAvailability: addForm.value.jobAvailability === "" ? undefined : addForm.value.jobAvailability,
            directManagerName: addForm.value.directManagerName,
            directManagerTelephone: addForm.value.directManagerTelephone,
            directManagerEmail: addForm.value.directManagerEmail,
            teamManager: addForm.value.teamManager,
            careerPossibility: addForm.value.careerPossibility === "" ? undefined : addForm.value.careerPossibility,
            fixedSalary: addForm.value.fixedSalary,
            bonus: addForm.value.bonus === "" ? undefined : addForm.value.bonus,
            averageBonusValue: addForm.value.averageBonusValue,
            otherBenefit: addForm.value.otherBenefit === "" ? undefined : addForm.value.otherBenefit,
            relocation: addForm.value.relocation,
            premiumRelocation: addForm.value.premiumRelocation,
            relocationHouse: addForm.value.relocationHouse,
            workingTools: addForm.value.workingTools === "" ? undefined : addForm.value.workingTools,
            implementationDuration: addForm.value.implementationDuration,
            numberCandidates: addForm.value.numberCandidates,
            warrantyPeriod: addForm.value.warrantyPeriod,
            probationPeriod: addForm.value.probationPeriod,
            levelDifficulty: addForm.value.levelDifficulty,
            numberCredits: addForm.value.numberCredits,
            projectImplementationBudget: addForm.value.projectImplementationBudget,
            similarProjects: addForm.value.similarProjects,
            responsibleIdForSimilarProjects: projResp,
            jobPurpose: addForm.value.jobPurpose,
            companyValues: companyValuesArray === [] ? undefined : companyValuesArray,
            responsibility: responsibilityArray,
            skillRequired: skillsArray,
            generalStudies: addForm.value.generalStudies === "" ? undefined : addForm.value.generalStudies,
            specializedStudies: addForm.value.specializedStudies,
            otherStudies: addForm.value.otherStudies,
            technicalTesting: technicalTestingArray,
            psychologicalTesting: psychologicalTestingArray,
            foreignLanguage: foreignLanguageArray,
            professionalCertifications: addForm.value.professionalCertifications === "" ? undefined : addForm.value.professionalCertifications,
            driverLicense: addForm.value.driverLicense === "" ? undefined : addForm.value.driverLicense,
            totalLevelWorkExperience: addForm.value.totalLevelWorkExperience,
            levelWorkExperienceInSimilarActivitySector: addForm.value.levelWorkExperienceInSimilarActivitySector,
            levelWorkExperienceInSimilarActivitySubSector: addForm.value.levelWorkExperienceInSimilarActivitySubSector,
            levelWorkExperienceInSimilarDepartment: addForm.value.levelWorkExperienceInSimilarDepartment,
            levelWorkExperienceInSimilarPosition: addForm.value.levelWorkExperienceInSimilarPosition,
            specificSoftwareForActivityPerformed: addForm.value.specificSoftwareForActivityPerformed === "" ? undefined : addForm.value.specificSoftwareForActivityPerformed,
            workProgram: addForm.value.workProgram === "" ? undefined : addForm.value.workProgram,
            workSpace: addForm.value.workSpace === "" ? undefined : addForm.value.workSpace,
            physicalEffortAvailability: addForm.value.physicalEffortAvailability === "" ? undefined : addForm.value.physicalEffortAvailability,
            physicalEffortDetail: addForm.value.physicalEffortDetail,
            idealAge: addForm.value.idealAge,
            recruitmentStage: recruitSteps,
            projectStrategy: addForm.value.projectStrategy,
            internChannel: internChannelArray,
            externChannel: externChannelArray,
            internalTechnicalTest: internalTechnicalTestArray,
            externalTechnicalTest: externalTechnicalTestArray,
            internalPhysiologicalTest: internalPhysiologicalTestArray,
            externalPhysiologicalTest: externalPhysiologicalTestArray,
            otherTest: otherTestArray,
            recruiters: recruitersArray,
            estimatedTravel: addForm.value.estimatedTravel,
            performedTravel: addForm.value.performedTravel,
            estimatedCommunication: addForm.value.estimatedCommunication,
            performedCommunication: addForm.value.performedCommunication,
            estimatedOther: addForm.value.estimatedOther,
            performedOther: addForm.value.performedOther,
            totalEstimatedBudget: addForm.value.totalEstimatedBudget,
            totalPerformedBudget: addForm.value.totalPerformedBudget,
            status: 'nou',
            budgetDiff: this.budgetDiff
        }

        if (addForm.valid) {
            this.projectsService.createProject(this.project).subscribe(resp =>
            {
                this.formResponse = true;
                this.formSent = true;
                setTimeout(() => {
                    this.router.navigate(['/sistemerp/proiecte/vizualizare/' + resp['reason']])
                }, 4000);
            }, error => {
                this.formResponse = false;
                this.formSent = true;
            })
            this.submitted = true;

        } else {
            this.formResponse = false;
            this.formSent = true;
        }
    }

    ngOnDestroy() {
        this.wizard = undefined;
    }

    trackByFunction(index, item) {
        return item.index;
    }

    public addCompanyValue(): void {
        this.form.companyValues.push({
            name: '',
            description: ''
        });
    }

    public addResponsibility(): void {
        this.form.responsibility.push({
            name: '',
            description: '',
            importance: 0,
            timePercentage: ''
        });
    }

    public addSkill(): void {
        this.form.skillRequired.push({
            abilityName: '',
            abilityDescription: '',
            abilityLevel: ''
        });
    }

    public addTechnicalTesting(): void {
        this.form.technicalTesting.push({
            name: '',
            level: ''
        });
    }

    public addPsychologicalTesting(): void {
        this.form.psychologicalTesting.push({
            name: '',
            level: ''
        });
    }

    public addLanguage(): void {
        this.form.foreignLanguage.push({
            language: '',
            level: ''
        });
    }

    public addInternChannel(): void {
        this.form.internChannel.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addExternChannel(): void {
        this.form.externChannel.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addInternalTechnicalTest(): void {
        this.form.internalTechnicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addExternalTechnicalTest(): void {
        this.form.externalTechnicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addInternalPhysiologicalTest(): void {
        this.form.internalPhysiologicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0,
        })
    }

    public addExternalPhysiologicalTest(): void {
        this.form.externalPhysiologicalTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addOtherTest(): void {
        this.form.otherTest.push({
            name: '',
            estimatedCost: 0,
            finalCost: 0,
            time: 0
        })
    }

    public addRecruiter(): void {
        this.form.recruiters.push({
            recruiterId: '',
            recruiterName: undefined,
            feeFixed: 0,
            feeEstimatedVariable: 0,
            feeEstimatedPerformed: 0,
            bonusFixed: 0,
            bonusEstimatedVariable: 0,
            bonusEstimatedPerformed: 0
        })
    }


    // --- Remove one group of fields from the form
    public removeCompanyValue(index: number): void {
        this.form.companyValues.splice(index, 1);
    }

    public removeResponsibility(index: number): void {
        this.form.responsibility.splice(index, 1);
    }

    public removeSkill(index: number): void {
        this.form.skillRequired.splice(index, 1);
    }

    public removeTechnicalTesting(index: number): void {
        this.form.technicalTesting.splice(index, 1);
    }

    public removePsychologicalTesting(index: number): void {
        this.form.psychologicalTesting.splice(index, 1);
    }

    public removeLanguage(index: number): void {
        this.form.foreignLanguage.splice(index, 1);
    }

    public removeInternChannel(index:number): void {
        this.form.internChannel.splice(index, 1);
    }

    public removeExternChannel(index:number): void {
        this.form.externChannel.splice(index, 1);
    }

    public removeInternalTechnicalTest(index:number): void {
        this.form.internalTechnicalTest.splice(index, 1);
    }

    public removeExternalTechnicalTest(index:number): void {
        this.form.externalTechnicalTest.splice(index, 1);
    }

    public removeInternalPhysiologicalTest(index:number): void {
        this.form.internalPhysiologicalTest.splice(index, 1);
    }

    public removeExternalPhysiologicalTest(index:number): void {
        this.form.externalPhysiologicalTest.splice(index, 1);
    }

    public removeOtherTest(index:number): void {
        this.form.otherTest.splice(index, 1);
    }

    public removeRecruiter(index:number): void {
        this.form.recruiters.splice(index, 1);
    }
}
